import { render, staticRenderFns } from "./BiodataDataDasar.vue?vue&type=template&id=6d62b0fc&"
import script from "./BiodataDataDasar.vue?vue&type=script&lang=js&"
export * from "./BiodataDataDasar.vue?vue&type=script&lang=js&"
import style0 from "./BiodataDataDasar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports